import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    OnDestroy,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { PersonaDTO } from "app/main/apps/shared/interfaces/persona.interface";
import { PlazoDTO } from "app/main/apps/shared/models/plazo.model";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { OrdenesDeTrabajoService } from "app/main/apps/shared/services/rest/ordenes-de-trabajo.service";
import { finalize } from "rxjs/operators";
import { DialogAsignarContratistaComponent } from "../dialog-asignar-contratista/dialog-asignar-contratista.component";
import { Subscription } from "rxjs";

import * as _moment from "moment";
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from "moment";
const moment = _rollupMoment || _moment;

@Component({
    selector: "app-dialog-contratistas",
    templateUrl: "./dialog-contratistas.component.html",
    styleUrls: ["./dialog-contratistas.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogContratistasComponent implements OnInit, OnDestroy {
    subscripciones: Subscription;
    constructor(
        public dialogRef: MatDialogRef<DialogContratistasComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            idGrupoServicio: number;
            descripcionGrupo: string;
            idComuna: number;
            idRegion: number;
            idOOTT: number;
            puedeAsignar: boolean;
            valorCotizado: number;
        },
        private _dialogSrvc: DialogService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _oottSrvc: OrdenesDeTrabajoService,
        private _notificacionSrvc: NotificacionesService
    ) {
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {}

    asignarContratista(event) {
        const { contratista, fcInicio, fcTermino } = event;

        const fcInicioMoment = moment(fcInicio);
        const fcTerminoMoment = moment(fcTermino);
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogAsignarContratistaComponent,
            "clase-dialog",
            "400px",
            {
                contratista,
                idOOTT: this.data.idOOTT,
                fcInicio: fcInicioMoment,
                fcTermino: fcTerminoMoment,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result) {
                this._fuseProgressBarService.show();
                const plazo = new PlazoDTO(
                    result.rango.inicio.toISOString().split("T")[0],
                    result.rango.termino.toISOString().split("T")[0]
                );
                this.subscripciones.add(
                    this._oottSrvc
                        .asignarContratista(
                            this.data.idOOTT,
                            contratista.nrRut,
                            plazo
                        )
                        .pipe(
                            finalize(() => this._fuseProgressBarService.hide())
                        )
                        .subscribe((resp) => {
                            this._notificacionSrvc.mostrarNotificacion(
                                `Contratista ${contratista.nombres} ${contratista.apellidos} asignado a OOTT ${this.data.idOOTT}`,
                                "success"
                            );
                            this._oottSrvc.refreshOOTT$.next(true);
                            //this._oottSrvc.contratistaAsingado$.next(contratista.id);
                            this.dialogRef.close();
                        })
                );
            }
        });
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
